function unwrapResponse(response) {
  if (response && Object.prototype.hasOwnProperty.call(response, 'data')) return response.data
  return response
}

function normalizeSupportDeviceSeriesResponse(response) {
  const data = unwrapResponse(response)
  if (!Array.isArray(data)) return []
  return data.map((series) => ({
    id: series.id,
    label: series.label,
    devices: Array.isArray(series.devices)
      ? series.devices.map((device) => ({
          ...device,
          name: device.model,
          coverUrl: device.mainImageUrl
        }))
      : []
  }))
}

function normalizeSupportDeviceDetailResponse(response) {
  const data = unwrapResponse(response)
  if (!data || !data.model) return null
  return {
    ...data,
    name: data.model,
    coverUrl: data.mainImageUrl,
    tutorials: Array.isArray(data.tutorials) ? data.tutorials : []
  }
}

function normalizeSupportFaqResponse(response) {
  const data = unwrapResponse(response)
  if (!Array.isArray(data)) return []
  return data.map((category) => ({
    id: category.id,
    label: category.label,
    items: Array.isArray(category.items) ? category.items : []
  }))
}

function groupSupportDeviceFaqs(categoriesResponse, deviceFaqs) {
  const itemsByTagId = new Map()
  ;(Array.isArray(deviceFaqs) ? deviceFaqs : []).forEach((faq) => {
    if (!faq || faq.tagId == null) return
    const items = itemsByTagId.get(faq.tagId) || []
    items.push(faq)
    itemsByTagId.set(faq.tagId, items)
  })

  return normalizeSupportFaqResponse(categoriesResponse)
    .map((category) => ({
      ...category,
      items: itemsByTagId.get(category.id) || []
    }))
    .filter((category) => category.items.length > 0)
}

function buildSupportDevicePath(model) {
  return `/support/${encodeURIComponent(String(model))}`
}

module.exports = {
  normalizeSupportDeviceSeriesResponse,
  normalizeSupportDeviceDetailResponse,
  normalizeSupportFaqResponse,
  groupSupportDeviceFaqs,
  buildSupportDevicePath
}
